// extracted by mini-css-extract-plugin
module.exports = {"scores":"LineRowScoresCyber_scores__XqA9W","score":"LineRowScoresCyber_score___f3PV"};